"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCAL_STORAGE_TTL = exports.AUTH_API_PREFIX = exports.ROSTERING_LICENSE_API_PREFIX = exports.ROSTERING_API_PREFIX = void 0;
exports.ROSTERING_API_PREFIX = 'roster';
exports.ROSTERING_LICENSE_API_PREFIX = 'license/api';
exports.AUTH_API_PREFIX = 'auth';
exports.LOCAL_STORAGE_TTL = 3600;
//# sourceMappingURL=sdk.constants.js.map